// extracted by mini-css-extract-plugin
module.exports = {"headerQuestion":"styles_headerQuestion__GfNnq","questionText":"styles_questionText__Gj4na","icon":"styles_icon__zpAMp","wrapperContent":"styles_wrapperContent__3ea1j"};